import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';

import { useAppDispatch, useAppSelector } from '../../../store';
import { uiActions } from '../slice';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Theme } from '../../themes/types';
import { PhotoIcon } from '@heroicons/react/24/solid';

export const ThemeChooser = () => {
  const themes = useAppSelector(state => state.themes);
  const currentThemeID = useAppSelector(state => state.ui.currentThemeID);

  const themesList: Theme[] = Object.values(themes);

  const currentTheme = currentThemeID ? themes[currentThemeID] : themesList[0];

  const dispatch = useAppDispatch();
  const setTheme = (themeID: string) => dispatch(uiActions.setCurrentThemeID(themeID));

  if (themesList.length === 0) {
    return null;
  }

  return (
    <Listbox
      onChange={setTheme}
      value={currentTheme?.id}
    >
      <Label className='ml-4 mr-2'>Theme:</Label>
      <div className='relative grow'>
        <ListboxButton
          className='relative w-full cursor-default rounded-sm bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-jw-blue sm:text-sm sm:leading-6'
        >
          <span className="flex items-center">
            <span className="block truncate">{currentTheme?.name}</span>
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
            <ChevronDownIcon
              aria-hidden="true"
              className="h-5 w-5 text-gray-400"
            />
          </span>
        </ListboxButton>
        <ListboxOptions
          className="absolute z-10 max-h-[33vh] w-full overflow-auto rounded-b-sm border bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm grid grid-cols-[auto_1fr]"
          transition
        >
          {
            themesList.map(
              (theme) => (
                <ListboxOption
                  className="data-[focus]:bg-blue-100 p-2 select-none grid grid-cols-subgrid col-span-2 items-center"
                  key={theme.id}
                  value={theme.id}
                >
                  {
                    theme.previewImage && (
                      <img
                        className='mr-2'
                        src={theme.previewImage}
                      />
                    )
                  }
                  {
                    !theme.previewImage && (
                      <div className='h-16 flex items-center justify-center'>
                        <PhotoIcon className='size-8 text-neutral-400' />
                      </div>
                    )
                  }
                  {theme.name}
                </ListboxOption>
              )
            )
          }
        </ListboxOptions>
      </div>
    </Listbox>
  );
};
